// extracted by mini-css-extract-plugin
export default {"container":"Alert-index__container--XzCyY","withCTA":"Alert-index__withCTA--ipe4p","text":"Alert-index__text--ZQKsD","buttonWrapper":"Alert-index__buttonWrapper--rhj0s"};